import slices from './slices';

export default {
  ...slices.plansSlice.actions,
  ...slices.enrollmentsSlice.actions,
};
